var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDescription = function SvgDescription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "description_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "description_svg__Description"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 18h8v-2H8zm0-4h8v-2H8zm-2 8q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 20V4q0-.824.588-1.413A1.93 1.93 0 0 1 6 2h8l6 6v12q0 .824-.587 1.413A1.93 1.93 0 0 1 18 22zm7-13h5l-5-5z",
    className: "description_svg__vector"
  }))));
};
export { SvgDescription as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIj48ZyBjbGFzcz0iRGVzY3JpcHRpb24iPjxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTggMThoOHYtMkg4djJabTAtNGg4di0ySDh2MlptLTIgOGMtLjU1IDAtMS4wMi0uMTk2LTEuNDEyLS41ODdBMS45MjYgMS45MjYgMCAwIDEgNCAyMFY0YzAtLjU1LjE5Ni0xLjAyLjU4OC0xLjQxM0ExLjkyNiAxLjkyNiAwIDAgMSA2IDJoOGw2IDZ2MTJjMCAuNTUtLjE5NiAxLjAyLS41ODcgMS40MTNBMS45MjYgMS45MjYgMCAwIDEgMTggMjJINlptNy0xM2g1bC01LTV2NVoiIGNsYXNzPSJ2ZWN0b3IiLz48L2c+PC9zdmc+";